module.exports = __webpack_public_path__ + "static/L5Y3s-53b71f2ad50579fe938d4577ab5334ad.jpg";